import {AfterViewInit, Injectable, OnChanges, OnInit} from '@angular/core';
import * as AWS from 'aws-sdk/global';
import {Observable, of, from, Subject} from 'rxjs';
import {tap, delay, switchAll, catchError} from 'rxjs/operators';

import Amplify, {Auth, Hub } from 'aws-amplify';
import { ICredentials } from '@aws-amplify/core';
import awsconfig from '../../aws-exports';
import {Router} from '@angular/router';
import {waitForAsync} from '@angular/core/testing';
import {CognitoUser, ICognitoUserData} from 'amazon-cognito-identity-js';

// tslint:disable-next-line:max-line-length
// [Cognito Identity Provider Client \- AWS SDK for JavaScript v3](https://docs.aws.amazon.com/AWSJavaScriptSDK/v3/latest/clients/client-cognito-identity-provider/index.html)
// ES6+ example
import { CognitoIdentityProviderClient, AddCustomAttributesCommand } from '@aws-sdk/client-cognito-identity-provider';
import {CognitoUserInterface, AuthState} from '@aws-amplify/ui-components';
import {Credentials, CredentialsOptions} from 'aws-sdk/lib/credentials';
import {CognitoIdentityCredentials} from 'aws-sdk/global';
import CognitoIdentityOptions = CognitoIdentityCredentials.CognitoIdentityOptions;
// ALC. [amazon\-cognito\-identity\-js \- npm](https://www.npmjs.com/package/amazon-cognito-identity-js)
// import 'cross-fetch/polyfill';
// import * as  AmazonCognitoIdentity from 'amazon-cognito-identity-js'; // GetCredentialsForIdentity
import * as CognitoIdentity from 'aws-sdk/clients/cognitoidentity';
import { environment } from '../../environments/environment';
import { GetCredentialsForIdentityResponse } from 'aws-sdk/clients/cognitoidentity';
import {IdentityProviderToken} from 'aws-sdk/clients/cognitoidentity';

// Set the region where your identity pool exists (us-east-1, eu-west-1)
const cognitoidentity = new CognitoIdentity({apiVersion: '2014-06-30'});


@Injectable(/*{
  // ALC. Good tested article with lifecycle of Services explained. [What is the lifecycle of a service in Angular 5 \- Stack Overflow]
  // (https://stackoverflow.com/questions/50056446/what-is-the-lifecycle-of-a-service-in-angular-5)
  providedIn: 'root'
}*/)
export class AuthService{
  public authState: AuthState;
  public user: CognitoUserInterface;
  public userSubject$: Subject<CognitoUserInterface> = new Subject();
  private idToken: string;
  public userPoolId: string;
  public cognitoClient: CognitoIdentityProviderClient;
  public awsConfigCognitoCredentialsProvider: any;
  public awsConfigCognitoCredentials: Credentials;
  public identityAuthorized = false;
  public authCredentials: CredentialsOptions;
  public authCredentialsSubject$: Subject<CredentialsOptions> = new Subject();
  // public identityAuthorizedSubject$ = new Subject();
  public setIdToken(): Promise<void>{
    return Auth.currentUserPoolUser().then(data => {
      this.idToken = data.signInUserSession.idToken.jwtToken ?? null;
      this.user = data;
      this.userPoolId = this.user.pool.userPoolId;
      // this.cognitoClient = this.user.pool.client;
      this.user.getSession((err, session) => {
        if (err) {
          console.log(err);
          return;
        }
        // ALC validated session
        console.log('session validity: ' + session.isValid());
        console.log('session token: ' + session.getIdToken().getJwtToken());
        // ALC build params
        const providerParams = {
          IdentityPoolId: awsconfig.aws_cognito_identity_pool_id, // awsconfig.aws_user_pools_id,
          Logins: {
            // Change the key below according to the specific region your user pool is in.
            // tslint:disable-next-line:max-line-length
            // 'cognito-idp.eu-central-1.amazonaws.com/eu-central-1_bOIyXG54S': session.getIdToken().getJwtToken() //
          }
        };
        const loginsKey = `cognito-idp.${awsconfig.aws_cognito_region}.amazonaws.com/${awsconfig.aws_user_pools_id}`;
        providerParams.Logins[loginsKey] = session.getIdToken().getJwtToken();
        // this.awsConfigCognitoCredentialsProvider = new AWS.CognitoIdentityCredentials( providerParams);
        AWS.config.credentials = new AWS.CognitoIdentityCredentials( providerParams);
        // this.awsConfigCognitoCredentials = this.awsConfigCognitoCredentialsProvider.get(() => {
        // @ts-ignore
        return AWS.config.credentials.get(( ) => {
            // Credentials will be available when this function is called.
            const awsConfigDebug = AWS.config;
            const accessKeyId = AWS.config.credentials.accessKeyId;
            const secretAccessKey = AWS.config.credentials.secretAccessKey;
            const sessionToken = AWS.config.credentials.sessionToken;
            this.authCredentials = AWS.config.credentials;
            this.authCredentialsSubject$.next(AWS.config.credentials);
            return AWS.config.credentials;
          });
      });
    });
  }
  public getCognitoCredentials(): Promise<void> { // Promise<void>
    // ALC. Now, having Identiy Id we can get Identity Credentials
    const loginsKey = `cognito-idp.${awsconfig.aws_cognito_region}.amazonaws.com/${awsconfig.aws_user_pools_id}`;
    const providerParams = {
      IdentityPoolId: awsconfig.aws_cognito_identity_pool_id,
      // this.user.signInUserSession.idToken,
      // CustomRoleArn: 'STRING_VALUE',
      Logins: {
        /* '<IdentityProviderName>': ... */
      }
    };
    providerParams.Logins[loginsKey] = this.user.signInUserSession.idToken.jwtToken; // [key: string]: IdentityProviderToken
    AWS.config.credentials  = new AWS.CognitoIdentityCredentials( providerParams);

    return ( AWS.config.credentials as AWS.CognitoIdentityCredentials ).getPromise()
      .then(() => {
        this.identityAuthorized = true;
      })
      .catch(err => {
        console.log(`auth.service.ts => err = ${err}`);
      });
  }

// tslint:disable-next-line:align
  public getIdToken(): string{
    return this.idToken;
  }
  constructor() {
    this.idToken = '';
  }

  // tslint:disable-next-line:max-line-length
    // Replaced by standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
    /*Hub.listen('auth', (data) => {
      console.log('Listening for all messages: ', data.payload.data);
      this.onAuthEvent(data.payload);
    });
    // this.checkIsLoggedIn();
  }
  isLoggedIn = false;
  // authObservable: Observable<any>;
  // store the URL so we can redirect after logging in
  redirectUrl: string;
  // Create an Observable out of a promise
  checkIsLoggedIn(): Observable<ICredentials> {
    const data =  from(Auth.currentCredentials());
    // Subscribe to begin listening for async result
    data.subscribe({next(response): void {
        console.log(response);
        if (response && response.authenticated) {
          console.log('loggedIn');
        } else {
          console.log('loggedOut');
        }
      },
      error(err): void { console.error('Error: ' + err); },
      complete(): void {
      console.log('Completed');
    }
    });
    return data.pipe(tap(response => {
        if (response && response.authenticated) {
          console.log('loggedIn');
          return this.isLoggedIn = true;
        } else {
          console.log('loggedOut');
          return this.isLoggedIn = false;
        }
      })
    );*/
  /*  login(): Observable<boolean> {
      return of(true).pipe(
        delay(10000),
        tap(val => this.isLoggedIn = true)
      );
    }*/
  // tslint:disable-next-line:max-line-length
  // Replaced by standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
  /*onAuthEvent(payload): void {
    // ... your implementation
    if (payload && payload.event && payload.event === 'signIn'){
      this.loggedIn();
    }
    if (payload && payload.event && payload.event === 'AuthStateChange' && payload.message && payload.message === 'signedin'){
      this.loggedIn();
    }
    if (payload && payload.event && payload.event === 'AuthStateChange' && payload.message && payload.message === 'signedout'){
      this.loggedOut();
    }
    if (payload && payload.event && payload.event === 'signOut' && payload.message && payload.message === 'A user has been signed out'){
      this.loggedOut();
    }
  }
  loggedIn(): void{
    this.isLoggedIn = true;
  }
  loggedOut(): void{
    this.isLoggedIn = false;
  }
  logout(): void {
    this.isLoggedIn = false;
  }*/
}



